import React, { useMemo } from "react";
import { EntityFilter } from "@whatslly/ui-components/EntityFilter";
import styles from "./TemplatesFilter.module.scss";
import { useDependencyInjector } from "@whatslly/commons/di";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import type { IImTemplatesStore } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
import { ImTemplatesStoreSymbol } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
const FilterButton: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const store = useDependencyInjector<IImTemplatesStore>(ImTemplatesStoreSymbol);

  const isDisabled = useMemo(() => store.templatesData?.state === "pending", [store.templatesData?.state]);

  return (
    <div className={classnames(styles.filtersButton, { [styles.disabled]: isDisabled, [styles.selected]: isOpen })}>
      <SvgV2 height={11} width={10.5} iconName={"filters-icon"} />
    </div>
  );
};

export const TemplatesFilter: React.FC<{ className?: string; collapsibleMenuClassName?: string }> = ({ className, collapsibleMenuClassName }) => {
  const store = useDependencyInjector<IImTemplatesStore>(ImTemplatesStoreSymbol);
  const { t } = useTranslation();

  return (
    <div className={className}>
      <EntityFilter
        title={t("templates.filters_title")}
        collapsibleMenuClassName={collapsibleMenuClassName}
        BooleanFilters={[
          {
            text: t("templates.show_only_own_by_me"),
            onChange: (newState: boolean) => {
              store.setShowOnlyOwnByMe(newState);
            },
            value: store.showOnlyOwnByMe,
            defaultValue: false,
          },
        ]}
        entities={[]}
        EntityFilterButton={FilterButton}
        hideButtons={true}
        filterSettings={[]}
      />
    </div>
  );
};
